module.exports = __webpack_public_path__ + "img/separator.c61878ce.svg";